import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
interface DrawerFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
}

// A labelled slot in the edit drawer: field label, its control, and any
// validation message underneath.
export const DrawerField = ({
  label,
  required,
  error,
  children,
}: DrawerFieldProps) => (
  <Stack className="w-full" align="start" gap={1}>
    <Text variant="label">
      {label}
      {required && <span className="ml-1 text-danger">*</span>}
    </Text>
    {children}
    {error && (
      <Text variant="caption" className="text-danger">
        {error}
      </Text>
    )}
  </Stack>
);
